import React, { useState } from "react";
import { getRazorPayOrders } from "../../../services/apiService";

const RazorPayOrders = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [orders, setOrders] = useState([]);
const handleSearch = async () => {
  if (!fromDate || !toDate) {
    alert("Please select both dates");
    return;
  }

  try {
    const res = await getRazorPayOrders(fromDate, toDate);
    console.log("API RESPONSE:", res);

    setOrders(Array.isArray(res) ? res : []);
  } catch (error) {
    console.error(error);
    alert("Failed to fetch records");
  }
};


const formatDate = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("en-IN");
};


  return (
    <div className="razor-wrapper">
      <h3 className="title">Razor-Pay Reports</h3>

      {/* Filters */}
      <div className="filter-box">
        <div>
          <label>From Date</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div>
          <label>To Date</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <button onClick={handleSearch}>Search</button>
      </div>

      {/* Table */}
      {orders.length > 0 && (
        <table className="razor-table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Customer</th>
              <th>Mobile</th>
              <th>Customer Paid</th>
              <th>Order Date</th>
              <th>Razor GST</th>
              <th>Razor Platform</th>
              <th>Other Charges</th>
              <th>After Razor Charges</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {orders.map((item, index) => (
              <tr key={index}>
                <td>{item.orderid}</td>
                <td>{item.customer_details?.[0]?.first_name}</td>
                <td>{item.customer_details?.[0]?.mobile}</td>
                <td>₹{Number(item.total || 0).toFixed(2)}</td>
                <td>{formatDate(item.orderdate)}</td>
                <td>
                  <input type="text" placeholder="GST" />
                </td>
                <td>
                  <input type="text" placeholder="Platform Fee" />
                </td>
                <td>
                  <input type="text" placeholder="Other Charges" />
                </td>
                <td>
                  <input type="text" placeholder="After All Cuttings" />
                </td>
                <td>
                  <button className="post-btn">Post</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Styles */}
      <style>{`
        .razor-wrapper {
          background: #fff;
          padding: 20px;
          border-radius: 8px;
        }

        .title {
          text-align: center;
          color: #005487;
          margin-bottom: 15px;
        }

        .filter-box {
          display: flex;
          gap: 15px;
          align-items: end;
          margin-bottom: 20px;
        }

        .filter-box label {
          font-size: 13px;
          display: block;
        }

        .filter-box input {
          padding: 6px;
          border: 1px solid #ccc;
          border-radius: 5px;
        }

        .filter-box button {
          padding: 7px 18px;
          background: #005487;
          color: #fff;
          border: none;
          border-radius: 5px;
          cursor: pointer;
        }

        .razor-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 13px;
        }

        .razor-table th,
        .razor-table td {
          padding: 10px;
          border-bottom: 1px solid #e5e7eb;
          text-align: center;
        }

        .razor-table thead {
          background: #f3f4f6;
        }

        .razor-table input {
          padding: 5px;
          width: 120px;
          border: 1px solid #d1d5db;
          border-radius: 5px;
        }

        .post-btn {
          background: #005487;
          color: white;
          border: none;
          padding: 5px 12px;
          border-radius: 5px;
          cursor: pointer;
        }

        .post-btn:hover {
          background: #005487;
        }
      `}</style>
    </div>
  );
};

export default RazorPayOrders;
